<button *ngIf="compact; else fullArticleCard" type="button" class="compact-article-card"
        [attr.aria-label]="'Read ' + article?.title">
  <span class="compact-article-image">
    <img [businessImage]="article?.mainImage" loading="lazy" decoding="async" width="56" height="56" alt="" />
  </span>
  <span class="compact-article-copy">
    <span class="compact-article-title">{{ article?.title }}</span>
    <span class="compact-article-description">{{ article?.description }}</span>
  </span>
</button>

<ng-template #fullArticleCard>
<div ngxMasonryItem class="masonry-item">
  <div class="card hero-card">
    <div class="gallery-view mt-0">
      <div class="row">
        <div class="col-12">
          <!-- masonryLazy releases layout immediately; reserved geometry keeps it
               stable while the shared image loader fetches visible images. -->
          <img masonryLazy class="article-main-image" [businessImage]="article?.mainImage"
               decoding="async" width="350" height="263" [alt]="article?.title || 'Article image'" />
        </div>
      </div>
    </div>
    <div class="card-head">
      <h4 class="card-title">
        {{article.title?.length >30? article.title?.substring(0,30)+'...' : article.title}}
        <!-- <img src="./assets/images/ic-leaf.svg" alt="Icon" /> -->
      </h4>
    </div>
    <div class="card-body">
      <p class="food-info">
        {{article.description?.length >118? article.description?.substring(0,118)+'...' :
        article.description }}
      </p>
      <div *ngIf="showMutlipleImage && article.carouselData?.Images?.length" class="gallery-view three-by-two ">
        <div class="row">
          <div class="col-4 dashboard-article-small-img" *ngFor="let img of article.carouselData?.Images;let i=index">
            <img *ngIf="i<3" masonryLazy [businessImage]="img" decoding="async" width="100" height="58" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</ng-template>
